import type { RepoCitation } from "@docreview/shared";

/**
 * Clickable source chips that deep-link into the in-app PDF viewer and
 * highlight the cited passage. Shared by per-deal chat and cross-deal "Ask".
 */
export default function CitationChips({
  citations,
  label = "Sources:",
}: {
  citations: RepoCitation[];
  label?: string;
}) {
  if (!citations || citations.length === 0) return null;
  return (
    <div className="mt-2 pt-2 border-t border-slate-200 flex flex-wrap gap-1.5">
      <span className="text-[11px] text-slate-400 mr-1">{label}</span>
      {citations.map((c, i) => (
        <a
          key={i}
          href={`/repository/pdf/${c.docId}?highlight=${encodeURIComponent(c.quote)}`}
          target="_blank"
          rel="noopener noreferrer"
          title={c.quote}
          className="inline-flex items-center gap-1 rounded bg-white border border-slate-200 px-1.5 py-0.5 text-[11px] hover:border-slate-400"
        >
          {/* Show the marker ONLY when the answer actually emits inline [n]
              references (per-deal chat). Cross-deal Ask builds citations from
              applied findings with no n and no inline markers, so numbering
              them would point at phantom references — render label-only. */}
          {c.n != null && <span className="font-semibold text-slate-400">[{c.n}]</span>}
          {c.label}
        </a>
      ))}
    </div>
  );
}
